"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { ArrowRight, Calendar } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function PostsGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <Card key={i} data-index={i} className="min-h-[300px] animate-pulse bg-muted/30" />)}
      </div>;
  }
  if (error) {
    return <div className="flex h-40 items-center justify-center rounded-xl border border-dashed border-border bg-muted/10">
        <p className="text-sm text-muted-foreground">Gagal memuat artikel.</p>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="flex h-40 items-center justify-center rounded-xl border border-dashed border-border bg-muted/10">
        <p className="text-sm text-muted-foreground">Belum ada artikel untuk ditampilkan.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => <Card key={post.id} data-index={i} className="flex h-full flex-col overflow-hidden border-border/60 shadow-sm transition-shadow duration-300 hover:shadow-md">
          {post.featuredImage ? <div className="aspect-[16/9] w-full overflow-hidden bg-muted">
              <img src={post.featuredImage} alt={post.title} className="h-full w-full object-cover transition-transform duration-500 hover:scale-105" />
            </div> : <div className="aspect-[16/9] w-full bg-muted/50" />}
          <CardHeader className="pb-4">
            <CardTitle className="text-xl leading-tight text-foreground md:line-clamp-2">
              {post.title}
            </CardTitle>
          </CardHeader>
          <CardContent className="flex-grow pb-6">
            <div className="text-sm text-muted-foreground md:line-clamp-3" dangerouslySetInnerHTML={{
          __html: post.excerpt || ""
        }} />
          </CardContent>
          <CardFooter className="mt-auto flex items-center justify-between border-t border-border/40 pt-4 text-secondary">
            <div className="flex items-center gap-2 text-xs font-semibold tracking-wide">
              <SafeHydrate><Calendar className="size-4" /></SafeHydrate>
              {post.date ? new Date(post.date).toLocaleDateString("id-ID", {
            day: "numeric",
            month: "long",
            year: "numeric"
          }) : "Baru saja"}
            </div>
            {post.link && <Link to={post.link}>
                <Button variant="ghost" size="sm" className="group -mr-3 text-secondary hover:bg-secondary/10 hover:text-secondary">
                  Baca
                  <ArrowRight className="ml-1 size-4 transition-transform group-hover:translate-x-1" />
                </Button>
              </Link>}
          </CardFooter>
        </Card>)}
    </div>;
}
export default function ZonaPemudaPancasila() {
  const wp_query_params = {
    post_type: "post",
    status: "publish",
    per_page: 3,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="zona-pemuda-pancasila" className="bg-gradient-to-b from-background to-muted/30 py-12 md:py-24">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="mb-12 flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div className="border-l-[6px] border-primary pl-6">
            <h2 className="font-sans text-3xl font-bold tracking-tight text-foreground md:text-4xl">
              Zona Pemuda Pancasila
            </h2>
            <p className="mt-3 max-w-2xl text-lg text-muted-foreground">
              Wadah inspirasi, kreativitas, dan aksi nyata generasi muda dalam
              membangun karakter bangsa berlandaskan nilai-nilai luhur.
            </p>
          </div>
          <Link to="#">
            <Button variant="outline" className="shrink-0 h-auto py-4 md:h-9 md:py-2">
              Lihat Semua Zona
              <ArrowRight className="ml-2 size-4" />
            </Button>
          </Link>
        </div>

        <PostsProvider wp_query={{
        post_type: "post",
        status: ["publish"],
        per_page: 3,
        order: "desc",
        orderby: "date"
      }}>
          <PostsGridConsumer />
        </PostsProvider>
      </div>
    </section>;
}